/**
 * @file useRuntimeStepsInfo.tsx
 *
 * @fileoverview Gets information about steps taking into account if there are bundles.
 */

import { getStepsinfo, JobWizardFlow } from '../config';
import { useJobWizardContext } from '~/jobiqo/components/Job/Wizard/context/useJobWizardContext';

/**
 * Get information about what steps to show for the user.
 *
 * @param flow
 *   The job wizard flow the user is in.
 * @returns
 *   Returns steps information for the job wizard.
 */
export function useRuntimeStepsInfo(flow: JobWizardFlow) {
  const {
    shouldShowBundlesStep,
    shouldShowUpgradesStep,
    shouldShowDestinationStep,
    shouldShowDestinationUpgradesStep,
  } = useJobWizardContext();
  const stepsInfo = getStepsinfo(
    flow,
    shouldShowBundlesStep,
    shouldShowUpgradesStep,
    shouldShowDestinationStep,
    shouldShowDestinationUpgradesStep,
  );

  return { stepsInfo };
}
